import React from "react";
import { graphql, StaticQuery } from "gatsby";

import { Logo } from "../logo/Logo";
import Newsletter from "../newsletter/Newsletter";
import Copyright from "../copyright/Copyright";

import styles from "./Footer.module.scss";
import classNames from "classnames/bind";

export const Footer = ({ className }) => {

    const cx = classNames.bind(styles);

    const classes = cx(
        "wrapper",
        className
    );

    return (
        <footer className={classes}>
            <div className={styles.inner}>
                <Newsletter
                    className={styles.newsletter}
                />

                <Logo
                    className={styles.logo}
                    color={"#FFF"}
                />
            </div>
            <Copyright
                className={styles.copyright}
            />
        </footer>
    )
}

